/**
 系统管理--用途管理
 */
import React, { PureComponent } from "react";
import FormCore from "@/components/display/form/formCore";
import ScGridTable from "@/components/display/table/gridTableCore";
import PropTypes from "prop-types";
import fetchHandler from "@/fetch/fetchHandler";
import moment from "moment";
import { Modal, message } from "antd";
import AddModal from "./AddModal";
import { getMaterialsTypeList, deleteMaterialsUse, getMaterialsUseList } from "@/fetch/fetchApi";
import RefreshGrid from "@/utils/refreshGrid";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { useAuth } from "@/utils/utils";

// eslint-disable-next-line arrow-parens
@connect((state) => state)
class UseManagement extends PureComponent {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.faultReportingList;
    this.state = {
      seeStubBindLockVisible: false,
      levelOption: [],
      formConfig: null,
      typeOption: [
        {
          text: this.props.intl.messages.faultReportingList.operationMode1, // '全部',
          value: "",
        },
      ],
      adviceContent: null,
      adviceVisible: false,
      remarkVisible: false,
      record: {},
    };
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.setState({
      formConfig: this.initFormConfig(),
    });
    this.init();
  }

  componentDidMount() {
    this.fetchApi();
  }

  /**
   * 页面内调用，关闭modal弹窗方法
   */
  modalVisibleAction(modalVisibleKey, visible) {
    this.setState({
      [modalVisibleKey]: visible,
    });
  }

  /**
   * 传递给modal弹窗内组件子方法，关闭modal弹窗方法
   */
  cancelModal(key) {
    this.setState({
      [key]: false,
    });
  }

  refresh = () => {
    RefreshGrid(this.context.store, "useManagementTable");
  };

  init() {
    this.setState({
      tableConfig: {
        tableKey: "useManagementTable",
        tableColumns: [
          {
            name: "用途名称", // 7'物料编号',
            key: "name",
            colType: "textCol",
            align: "left",
          },
          {
            name: "创建时间", // '物料名称',
            key: "createTime",
            colType: "textCol",
            align: "left",
          },
          {
            name: "操作", // 操作
            key: "action",
            colType: "action", // 操作列，可定义多种操作。
            actionMap: [
              useAuth("901703")
                ? {
                    type: "href",
                    actionName: "编辑", // 默认actionName
                    // 根据grid数据 自定义显示actionName
                    handler: (res) => {
                      this.setState({
                        record: res,
                        remarkVisible: true,
                      });
                    },
                  }
                : "",
              useAuth("901704")
                ? {
                    type: "confirm",
                    actionName: "删除",
                    handler: (record) => {
                      fetchHandler(deleteMaterialsUse, {
                        id: record.key,
                      }).then((res) => {
                        if (res && (res.code === "200" || res.code === "success")) {
                          message.success("操作成功");
                          RefreshGrid(this.context.store, "useManagementTable");
                        }
                      });
                    },
                  }
                : "",
            ],
          },
        ],
        tableChange: () => {},
        tableParam: {
          pagecount: 10,
        },
        dataApi: getMaterialsUseList,
        autoRefresh: !1, // 设置为true 直接加载grid数据
      },
    });
  }

  initFormConfig = () => {
    const formConfig = {
      childItems: [
        {
          type: "input",
          placeholder: "请输入用途名称", // '请输入物料编码',
          param: {
            name: "name",
            type: "string",
          },
          labelName: "用途名称", // '故障名称:',
          required: false,
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            useAuth("901701")
              ? {
                  btnType: "submit",
                  // icon: 'search',
                  text: this.internationalization.btn1, // '查询'
                }
              : "",
            useAuth("901702")
              ? {
                  btnType: "button",
                  // icon: 'search',
                  text: "新增用途", // '查询'
                  handler: () => {
                    this.setState({
                      record: {},
                      remarkVisible: true,
                    });
                  },
                }
              : "",
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      defaultParams: {},
      tableKey: "useManagementTable",
      tablePage: "故障上报",
    };

    return formConfig;
  };

  fetchApi = (param) => {
    // 当设置formTarget为grid时，执行自定义提交事件。
    if (this.state.formConfig.formTarget === "grid") {
      return;
    }
    // 请求fetch 对象，带入生成参数
    // 如果在modal中的表单提交，请执行这里
    if (this.props.modalSubmit) {
      return this.props.modalSubmit(param);
    } else {
      // 如果正常页面中的表单提交，请执行下面
      return RefreshGrid(this.context.store, "useManagementTable", param);
    }
  };

  openTab(param, e) {
    this.props.onAdd.bind(window.LayoutTab)(e, param);
  }

  render() {
    const Content = (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi} />
        </div>
        <div className="page-panel gzsbTable">
          <ScGridTable config={this.state.tableConfig} />
        </div>

        {this.state.remarkVisible && (
          <AddModal
            onCancel={() => this.setState({ remarkVisible: false })}
            refresh={this.refresh}
            record={this.state.record}
          />
        )}
      </div>
    );

    return Content;
  }
}

export default injectIntl(UseManagement);



// WEBPACK FOOTER //
// ./src/AntD/pages/system/useManagement/index.js